export class BrowserConnectivityRuntime {
  public isOnline(): boolean {
    if (typeof navigator === 'undefined') {
      return true;
    }

    return navigator.onLine !== false;
  }
}